export const getAddressObject = ({
  streetNumber, // Retrocompatibility: use line
  streetName, // Retrocompatibility: use line
  line,
  postalCode,
  city,
  district,
  state,
  country,
  coordinates,
  text,
}: Partial<{
  streetNumber: string | number;
  streetName: string; // Retrocompatibility: use line
  line: string | unknown[];
  postalCode: string;
  city: string;
  district: string;
  state: string;
  country: string;
  coordinates: {
    longitude?: number;
    latitude?: number;
  };
  text: string;
}>) => {
  const _line = Array.isArray(line)
    ? line.filter(Boolean).join(", ")
    : line ?? `${streetNumber ?? ""} ${streetName ?? ""}`;

  const textAddress = [
    _line,
    `${postalCode ?? ""} ${city ?? ""}`,
    district ?? "",
    state ?? "",
    country ?? "",
  ]
    .map((v) => v.trim())
    .filter(Boolean)
    .join(", ");

  return {
    text: textAddress ? textAddress : text ?? "",
    line: _line,
    postalCode,
    city,
    district,
    state,
    country,
    coordinates: {
      latitude: coordinates?.latitude,
      longitude: coordinates?.longitude,
    },
  };
};
